module.exports = __webpack_public_path__ + "img/icon35.f5a4ee53.png";